export const SourceOptions = [
    {
        text:"All",
        value:"all"
    },
    {
        text:"Pennystocks",
        value:"pennystocks"
    }
]